module.exports = __webpack_public_path__ + "media/images/landing/icon-special-offer-9fd3d71286e65d3101f56680f33faa8a.svg";